import React from 'react';

import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import { Container } from './styles';

import { GraficoProps } from './interface';

const Grafico: React.FC<GraficoProps> = ({ dias }) => {
  return (
    <Container>
      <ResponsiveContainer>
        <LineChart
          data={dias}
          margin={{
            top: 10,
            right: 20,
            left: 20,
            bottom: 30,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="nome"
            stroke={'#999'}
            fontSize={10}
            angle={0}
            textAnchor="end"
            tickMargin={10}
            dx={25}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 5,
              borderColor: '#fff',
              fontSize: 12,
              textTransform: 'uppercase'
            }}
            labelStyle={{ color: '#333' }}
            cursor={{ fill: 'rgba(0,0,0, 0.08)' }}
            formatter={(value: any) =>
              `${Number(value).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}`
            }
            labelFormatter={(value: any) => `${String(value).toUpperCase()}`}
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#f15825"
            strokeWidth={4}
            activeDot={{ r: 14 }}
          />
          <Line
            type="monotone"
            dataKey="frete"
            stroke="#53a4bd"
            strokeWidth={4}
            activeDot={{ r: 14 }}
          />
          <Line
            type="monotone"
            dataKey="desconto"
            stroke="#7e431c"
            strokeWidth={4}
            activeDot={{ r: 14 }}
          />
          <Line
            type="monotone"
            dataKey="produtos"
            stroke="#1a4086"
            strokeWidth={4}
            activeDot={{ r: 14 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default Grafico;
